import React from 'react';
import { Stack, Typography, Card, Link, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

function HospitalIngestionsModal({ open, hospitals, onClose }) {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{ elevation: 8 }}
        >
            <DialogTitle>
                Hospital Ingestions ({hospitals.length})
            </DialogTitle>
            <DialogContent>
                <Stack spacing={1} sx={{ mt: 1 }}>
                    {[...hospitals].sort((a, b) => (a.name || a.code).localeCompare(b.name || b.code)).map((hospital, index) => (
                        <Card key={index} variant="outlined" sx={{ p: 1.5 }}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Stack>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                        {hospital.name || hospital.code}
                                    </Typography>
                                    <Typography variant="caption" sx={{ fontFamily: 'monospace', color: 'text.secondary' }}>
                                        {hospital.hospital_id ? `ID: ${hospital.hospital_id} | ` : ''}Code: {hospital.code}
                                    </Typography>
                                </Stack>
                                {hospital.hospital_id && (
                                    <Link 
                                        href={`/superSettings/hospitals/${hospital.hospital_id}/imports`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{ 
                                            fontSize: '12px',
                                            textDecoration: 'none',
                                            '&:hover': {
                                                textDecoration: 'underline'
                                            }
                                        }}
                                    >
                                        View Imports
                                    </Link>
                                )}
                            </Stack>
                        </Card>
                    ))}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}

export default HospitalIngestionsModal;